import { render, staticRenderFns } from "./NoticeShow.vue?vue&type=template&id=efaf3378&scoped=true&"
import script from "./NoticeShow.vue?vue&type=script&lang=js&"
export * from "./NoticeShow.vue?vue&type=script&lang=js&"
import style0 from "./NoticeShow.vue?vue&type=style&index=0&id=efaf3378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf3378",
  null
  
)

export default component.exports